export enum ServiceType {
  Trash = 1,
  Recycling = 2,
}
